import React, { useEffect, useState } from "react";
import axios from "axios";
import { apiUrl } from "../../../constants";
import styles from "./FormSettingsItem.module.css";

const FormSettingsItem = ({ handleClick, item, id, title }) => {
  const [publisherIcon, setPublisherIcon] = useState();
  const [publisherId, setPublisherId] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, toggleLoading] = useState(false);

  useEffect(() => {
    if (publisherId) {
      getPublisherIcon();
    }
  }, [publisherId]);

  useEffect(() => {
    if (id !== undefined && title === "publisher") {
      setPublisherId(id);
    }
  }, []);

  async function getPublisherIcon() {
    setErrorMessage("");
    const jwtToken = localStorage.getItem("token");
    toggleLoading(true);
    try {
      const { data } = await axios.get(
        `${apiUrl}/formsettings/publishersicon/${id}`,
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        }
      );

      let fileType = "";
      if (data.charAt(0) === "/") {
        fileType = "jpeg";
      }
      if (data.charAt(0) === "i") {
        fileType = "png";
      }

      const image = `data:image/${fileType};base64,${data}`;
      setPublisherIcon(image);
    } catch (e) {
      console.error(e);

      if (e.response !== undefined) {
        setErrorMessage(e.response.data.message);
      } else {
        setErrorMessage("Something went wrong. Please try again later.");
      }
    }
    toggleLoading(false);
  }

  return (
    <div className={styles["display-item"]} onClick={handleClick}>
      {errorMessage.length > 0 && (
        <p className={styles.error}>{errorMessage}</p>
      )}
      {publisherIcon && (
        <div className={styles["icon-wrapper"]}>
          <img src={publisherIcon} />
        </div>
      )}
      <p className={styles["item-wrapper"]}>{item}</p>
      {loading && <p>Loading...</p>}
    </div>
  );
};

export default FormSettingsItem;
